import { render } from "./PatientNoteModal.vue?vue&type=template&id=03db5155&scoped=true"
import script from "./PatientNoteModal.vue?vue&type=script&lang=js"
export * from "./PatientNoteModal.vue?vue&type=script&lang=js"

import "./PatientNoteModal.vue?vue&type=style&index=0&id=03db5155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03db5155"]])

export default __exports__